import theme from '@qnpm/q-theme';
import Styles from './styles';
const { responsive: { scale } } = theme;
export function getCardStyles(props) {
    const { needScale, size, radius, backgroundColor, opacity = 1 } = props;
    // 按钮类型
    const cardStyle = {};
    if (backgroundColor) {
        cardStyle.backgroundColor = backgroundColor;
    }
    if (opacity) {
        cardStyle.opacity = opacity;
    }
    if (radius) {
        cardStyle.borderRadius = getCardRadiusStyle(props);
    }
    if (size) {
        cardStyle.width = needScale ? formatNumber(size.width) : size.width;
        cardStyle.height = needScale ? formatNumber(size.height) : size.height;
    }
    return cardStyle;
}
/**
 * 将字符串类型的数字字符串转换为number类型
 * @param value 数字or数字字符串
 */
function formatNumber(value) {
    if (typeof value === 'string') {
        return scale(parseFloat(value));
    }
    return scale(value || 0);
}
export function getCardRadiusStyle(props) {
    const { needScale, radius = 'small', size } = props;
    let borderRadius = Styles[radius] ? Styles[radius].borderRadius : 0;
    if (size) {
        const { width = 0, height = 0 } = size;
        if (radius === 'circle') {
            const tWidth = needScale ? formatNumber(width) : width;
            const tHeight = needScale ? formatNumber(height) : height;
            borderRadius = Math.min(tWidth, tHeight) * 0.5;
        }
    }
    return borderRadius;
}
